import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import SanitizedHtml from "../../components/SanitizedHtml";
import { setSubControlsDisabled, toggleSubControls } from "../subControls";
import hasRenderableControl from "../hasRenderableControl";
import buildControl from "../buildControl";
import { updateGroupFeedback } from "../../validation/validityStyling";

const buildMultiChoiceCheckQuestion = (question) => {
  return (
    <>
      {question.Options &&
        question.Options.map((o, i) => {
          const subControlsId = `sub_${question.Name}_${o.Name}`;
          return (
            <Form.Check
              key={i}
              type="checkbox"
              label={o.Label}
              name={question.Name}
              data-name={question.Name}
              data-required={question.IsMandatory}
              data-group-validated="true"
              value={o.Name}
              required={question.IsMandatory}
              onChange={(event) => {
                // data-* attributes always render as strings, so this must
                // be compared explicitly - a bare truthy check would treat
                // the literal string "false" as required too.
                const required =
                  event.target.getAttribute("data-required") === "true";
                const name = event.target.getAttribute("data-name");
                const newValue = event.target.checked;
                const checkboxes = Array.from(
                  document.querySelectorAll(`input[name="${name}"]`),
                );
                const checkedCount = checkboxes.filter(
                  (cb) => cb.checked,
                ).length;

                if (required) {
                  checkboxes.forEach((cb) => {
                    if (checkedCount === 0) {
                      cb.setAttribute("required", "");
                    } else {
                      cb.removeAttribute("required");
                    }
                  });
                }

                const minSelections = question.SelectAtLeast;
                const maxSelections = question.SelectAtMost;
                let message = "";
                if (minSelections && checkedCount < minSelections) {
                  message = `Please select at least ${minSelections} option${minSelections === 1 ? "" : "s"}.`;
                } else if (maxSelections && checkedCount > maxSelections) {
                  message = `Please select at most ${maxSelections} option${maxSelections === 1 ? "" : "s"}.`;
                }

                checkboxes.forEach((cb) => {
                  cb.setCustomValidity(message);
                  const newClass = cb.className
                    .replace("is-invalid", "")
                    .replace("is-valid", "")
                    .trimEnd();
                  cb.className = message
                    ? `${newClass} is-invalid`
                    : newClass;
                });
                updateGroupFeedback(event.target);

                toggleSubControls(subControlsId, newValue);
              }}
            />
          );
        })}

      {/* Sub-controls for all options, rendered after all checkboxes */}
      {question.Options &&
        question.Options.map((o, i) => {
          const subControlsId = `sub_${question.Name}_${o.Name}`;
          return (
            o.Questions && (
              <div
                key={i}
                id={subControlsId}
                className="ms-4"
                style={{ display: "none" }}
                ref={(el) => setSubControlsDisabled(el, true)}
              >
                {o.Questions.map((subQuestion, si) =>
                  hasRenderableControl(subQuestion) ? (
                    <Card className="mb-3" key={si}>
                      <Card.Body>
                        <Card.Title as="div">
                          <div className="d-flex align-items-start">
                            {subQuestion.IsMandatory && (
                              <span className="text-danger me-1">*</span>
                            )}

                            <SanitizedHtml
                              html={subQuestion.MainText}
                              className="question-main-text"
                            />
                          </div>
                        </Card.Title>

                        <SanitizedHtml
                          html={subQuestion.Description}
                          className="card-text question-description"
                        />
                        <Form.Group
                          className="mb-3"
                          data-error-text={subQuestion.ErrorText || ""}
                        >
                          {buildControl(subQuestion)}
                        </Form.Group>
                      </Card.Body>
                    </Card>
                  ) : null,
                )}
              </div>
            )
          );
        })}

      {/* Other input */}
      {question.AddOther && (
        <Form.Control
          type="text"
          name={`${question.Name}_other`}
          placeholder="Please specify"
          className="mt-2"
        />
      )}
    </>
  );
};

export default buildMultiChoiceCheckQuestion;
